import { noSubselectionAllowedMessage } from 'graphql/validation/rules/ScalarLeafs'
import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { VolumeUpFill } from 'react-bootstrap-icons'
import { ChoicesContainer, QuestionText } from '../../theme'
import AppAudio from '../AppAudio'
import CorrectImagesChoices from './QuestionChoices/CorrectImagesChoices'
import ImageChoices from './QuestionChoices/ImageChoices'
import MatchTheFollowing from './QuestionChoices/MatchTheFollowing'
import Referencechoices from './QuestionChoices/Referencechoices'
import ScatteredImage from './QuestionChoices/ScatteredImage'
import TextChoices from './QuestionChoices/TextChoices'

const ROW_COUNT = 2
const COL_COUNT = 2

function Question(props) {
  const [audio, setAudio] = useState('')
  const [audioLength, setAudioLength] = useState(200000)
  const [audioState, setAudioState] = useState(false)
  const [displayColumnMatch, setDisplayColumnMatch] = useState(true)
  const [columnMatchArray, setColumnMatchArray] = useState([])
  const [choice, setChoice] = useState([])
  const [correctArray, setCorrectArray] = useState([])
  const [incorrectArray, setIncorrectArray] = useState([])
  const [referenceData, setReferenceData] = useState()
  // false means audio is working

  const plumbInstance = null
  const {
    question,
    choices,
    answerIndex,
    onSelect,
    selected,
    type,
    rightcolumn,
    leftcolumn,
    reference,
    answer,
    neutralQuestion,
    correctAnswer,
    wrongAnswer,
    confirmResult,
    parentScreen,
    visible,
    referenceIncorrectOption,
    referenceCorrectOption,
    quesType,
    quesId,
    submit,
    finalAttempt,
    loading,
    answerArray,
    submitLoading,
    attemptPercentage,
    subject,
    weekData,
    age,
    questionNumber,
  } = props

  useEffect(() => {
    setAudioState(false)
  }, [type])

  useEffect(() => {
    if (loading) {
      setColumnMatchArray([])
      setChoice([])
      setCorrectArray([])
      setIncorrectArray([])
    }
  }, [loading])

  useEffect(() => {
    if (choices || referenceCorrectOption || referenceIncorrectOption) {
      if (choices.length > 0) {
        setChoice(choices)
      } else if (!referenceCorrectOption) {
        return
      } else if (referenceCorrectOption.length > 0) {
        setCorrectArray(referenceCorrectOption)
        setIncorrectArray(referenceIncorrectOption)
      } else {
        setChoice([])
      }
      setReferenceData(reference)
      //  else if (referenceIncorrectOption.length > 0) {
      //   console.log('choice', referenceIncorrectOption)
      // }
      // console.log('choice',referenceIncorrectOption)
      // console.log('questionData123', choices)
    }
  }, [
    type,
    choices,
    referenceIncorrectOption,
    referenceCorrectOption,
    attemptPercentage,
    reference,
    questionNumber,
  ])

  useEffect(() => {
    let leftColumnArray = []
    let rightColumnArray = []
    let choiceArray = []
    if (type === 'col' && leftcolumn.length > 0 && rightcolumn.length > 0) {
      leftcolumn.map((val, index) => {
        let obj = {}
        obj.label = val
        obj.type = 'question'
        obj.correctAnswer = rightcolumn[index]
        leftColumnArray.push(obj)
      })
      rightcolumn.map((val, index) => {
        let obj = {}
        obj.label = val
        obj.type = 'answer'
        obj.answerId = index + 1
        rightColumnArray.push(obj)
      })
      rightColumnArray = rightColumnArray.sort(() => Math.random() - 0.5)
      choiceArray = leftColumnArray.concat(rightColumnArray)
      let choicesArray = choiceArray.map((val, index) => ({
        ...val,
        id: index + 1,
      }))
      setColumnMatchArray(JSON.parse(JSON.stringify(choicesArray)))
    }
  }, [type, rightcolumn, leftcolumn, attemptPercentage])

  const audioStateHandler = async () => {
    await setAudioState(true)
  }

  const replayAudioHandler = async () => {
    await setAudioState(false)
    var audio = document.getElementById('audio1')
    audio.currentTime = 0
    audio.play()
  }

  // useEffect(() => {
  //   replayAudioHandler()
  // },[choices])

  const handleQuestionClick = () => {
    if (
      window &&
      window.location &&
      window.location.pathname.includes('kid-assessment')
    ) {
      window.sendEvent({
        type: 'MA_QUESTION_CLICK',
        data: {
          AssessmentSubject: subject,
          question: question,
          answer: answerIndex,
          week: weekData?.currentWeek?.week,
          Age: age,
          type: quesType,
        },
      })
    }
  }

  return (
    <>
      <div>
        <QuestionText
          style={{
            // textAlign: 'center',
            marginLeft: '0px',
            marginRight: '0px',
            background: '#FFFCED',
          }}
          className="row container "
        >
          <div className="col " onClick={handleQuestionClick}>
            {question}
          </div>
          {type == 'audioText' || type == 'audioImage' ? (
            <div className="col-2">
              {type == 'audioText' || type == 'audioImage' ? (
                audioState ? (
                  <VolumeUpFill onClick={replayAudioHandler} />
                ) : (
                  <VolumeUpFill onClick={replayAudioHandler} />
                )
              ) : null}
            </div>
          ) : (
            noSubselectionAllowedMessage
          )}
          {type == 'audioText' || type == 'audioImage' ? (
            !audioState ? (
              <AppAudio
                audio={referenceData}
                audioStateHandler={audioStateHandler}
              />
            ) : null
          ) : null}
        </QuestionText>
        <div>
          {type == 'refImage' ? (
            <div className="mt-4" style={{ textAlign: 'center' }}>
              <img
                src={referenceData}
                style={{ height: '230px', width: '100%' }}
              />
            </div>
          ) : null}
        </div>
        <ChoicesContainer>
          {(() => {
            if (type === 'image' && choice.length > 0) {
              return (
                <ImageChoices
                  choices={choice}
                  value={selected}
                  onSelect={onSelect}
                  correctIndex={answerIndex}
                  confirmResult={confirmResult}
                  parentScreen={parentScreen}
                  quesType={quesType}
                  quesId={quesId}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (type === 'text' && choice.length > 0) {
              return (
                <TextChoices
                  choices={choice}
                  value={selected}
                  onSelect={onSelect}
                  correctIndex={answerIndex}
                  confirmResult={confirmResult}
                  parentScreen={parentScreen}
                  quesType={quesType}
                  quesId={quesId}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (type == 'audioText' && choice.length > 0) {
              return (
                <TextChoices
                  choices={choice}
                  value={selected}
                  onSelect={onSelect}
                  correctIndex={answerIndex}
                  confirmResult={confirmResult}
                  parentScreen={parentScreen}
                  quesType={quesType}
                  quesId={quesId}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (type == 'audioImage' && choice.length > 0) {
              return (
                <ImageChoices
                  choices={choice}
                  value={selected}
                  onSelect={onSelect}
                  correctIndex={answerIndex}
                  confirmResult={confirmResult}
                  parentScreen={parentScreen}
                  quesType={quesType}
                  quesId={quesId}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (
              type == 'scatter' &&
              correctArray.length > 0 &&
              incorrectArray.length > 0
            ) {
              return (
                <ScatteredImage
                  referenceIncorrectOption={incorrectArray}
                  referenceCorrectOption={correctArray}
                  onSelect={onSelect}
                  quesId={quesId}
                  submit={submit}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (type == 'refImage' && choice.length > 0) {
              return (
                <CorrectImagesChoices
                  choices={choice}
                  value={selected}
                  onSelect={onSelect}
                  correctIndex={answerIndex}
                  confirmResult={confirmResult}
                  parentScreen={parentScreen}
                  quesType={quesType}
                  quesId={quesId}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (
              type == 'referenceCol' &&
              correctArray.length > 0 &&
              incorrectArray.length > 0
            ) {
              return (
                <Referencechoices
                  referenceIncorrectOption={incorrectArray}
                  referenceCorrectOption={correctArray}
                  onSelect={onSelect}
                  quesId={quesId}
                  reference={reference}
                  submit={submit}
                  finalAttempt={finalAttempt}
                />
              )
            } else if (type == 'col' && columnMatchArray.length > 0) {
              return (
                <MatchTheFollowing
                  choices={columnMatchArray}
                  visible={visible}
                  quesId={quesId}
                  rightcolumn={rightcolumn}
                  leftcolumn={leftcolumn}
                  onSelect={onSelect}
                  submit={submit}
                  finalAttempt={finalAttempt}
                  resetPlumb={props.resetPlumb}
                  loading={loading}
                  answerArray={answerArray}
                />
              )
            } else {
              return (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: '50vh' }}
                >
                  <Spinner animation="border" variant="success" />
                </div>
              )
            }
          })()}
        </ChoicesContainer>
      </div>
    </>
  )
}

export default Question
